import type { IconPrimitiveProps } from 'types';

const IconTrustDelivery = (props: IconPrimitiveProps) => {
  const {
    size = 24,
    ...rest
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      {...rest}
    >
      <g stroke="green" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} clipPath="url(#trust_delivery_svg__a)">
        <path d="M7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM17 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
        <path d="M5 17H3V6a1 1 0 0 1 1-1h9v12m-4 0h6m4 0h2v-6m0 0h-8m8 0-3-5h-5" />
      </g>
      <defs><clipPath id="trust_delivery_svg__a"><path fill="#fff" d="M0 0h24v24H0z" /></clipPath></defs>
    </svg>
  );
};
export default IconTrustDelivery;
